import React from "react";
import { Field, getIn } from "formik";
import has from "lodash/has";
import SelectInputBox from "./SelectInputBox";

const FormSelectInput = ({
  name = "",
  label,
  helperText = "",
  disabled,
  onChange,
  fullWidth = true,
  multiple,
  placeholder = "",
  size = "small",
  options = [],
  ...rest
}) => {
  const id = name;
  const handleChange = (formikOnChange) => (e) => {
    if (onChange) {
      onChange(e);
    }
    formikOnChange(e);
  };
  return (
    <Field name={name}>
      {({
        field: { value, onChange: formChange, onBlur },
        form: { errors, touched },
      }) => {
        return (
          <SelectInputBox
            name={name}
            value={value}
            options={options}
            label={label}
            multiple={multiple}
            multiline
            onChange={handleChange(formChange)}
            onBlur={onBlur}
            fullWidth={fullWidth}
            disabled={disabled}
            size={size}
            error={has(errors, id) && has(touched, id)}
            helperText={
              has(errors, id) && has(touched, id)
                ? getIn(errors, id)
                : helperText
            }
            {...rest}
          />
        );
      }}
    </Field>
  );
};

export default FormSelectInput;
